import routeName from '@/router/constant';
import { guideRoutes } from '@/utils/guideRoutes';

const typeName = 'vip';

export const vipHeader = [
    {
        path: `${typeName}-login`,
        name: routeName.VIP_LOGIN,
        component: () => import('@/views/vip/login/Index.vue'),
        meta: {
            auth: false,
            metaTitle: '富邦人壽VIP專屬禮讚',
            pageTitle: '富邦人壽VIP專屬禮讚',
            subtitle: '請以VIP身分登入',
        },
    },
    {
        path: `${typeName}Info`,
        name: routeName.VIP_INFO,
        component: () => import('@/views/vip/info/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '富邦人壽VIP專屬禮讚',
            pageTitle: '富邦人壽VIP專屬禮讚',
            unableBack: true,
            backPage: routeName.VIP_LOGIN,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.VIP_LOGIN];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
];
